export default function crmFormController($scope, $http) {

    $scope.submitting = false;

    $scope.submitForm = function(isValid, $event) {

        if (isValid) {

            $event.preventDefault();
            $scope.submitting = true;

            $http({
                    method: 'POST',
                    url: '/webapi/crmform/submitajax',
                    data: $.param($scope.formData), // pass in data as strings
                    headers:
                    {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                    } // set the headers so angular passing info as form data (not request payload)
                })
                .then(function(resp) {
                    $scope.responseCode = resp.data.code;
                    $scope.responseMessage = resp.data.message;
                    $scope.crmForm.$setPristine();
                    $scope.submitting = false;

                    if (resp.data.code === 200) {
                        $scope.done = true;
                    }
                });
        }

        return false;
    }
};
